import axios from "axios";
import { CustomerListUpdate } from "@contracts/lists";
import { PageAdventureList } from "@contracts/pages";

// Manages Adventure Walls
export default {
  // Updates an individual list (does NOT impact the list pointers, ex. homepage lists)
  async updateList(communityId: string, listToUpdate: PageAdventureList): Promise<PageAdventureList> {
    // Build the update payload
    const adventureIds = listToUpdate.adventures.map(i => i.id);
    const adventureIdsString = adventureIds.join(",");
    var payload = {
      id: listToUpdate.id,
      name: listToUpdate.name,
      includeAllAdventures: listToUpdate.includeAllAdventures,
      maxCount: listToUpdate.maxCount,
      randomize: listToUpdate.randomize,
      adventureIds: adventureIdsString,
    } as CustomerListUpdate;

    const config = { headers: { "Content-Type": "application/json" } };
    return await axios.put(`${import.meta.env.VITE_API_URL}/adv-wall-admin/${communityId}/lists/${listToUpdate.id}`, JSON.stringify(payload), config);
  },

  // Loads an individual list from the server
  async loadAdventureSummaryForList(communityId: string, listId: string): Promise<PageAdventureList> {
    const { data } = await axios.get(`${import.meta.env.VITE_API_URL}/adv-wall-admin/${communityId}/lists/${listId}`);
    return data;
  },

  // ---Integration specific---

  async createSiteIntegrationList(communityId: string, name: string): Promise<string> {
    // Server generates the Id
    const config = { headers: { "Content-Type": "application/json" } };
    const response = await axios.post(`${import.meta.env.VITE_API_URL}/adv-wall-admin/${communityId}/widgets`, JSON.stringify(name), config);

    return response.data.id;
  },

  async deleteSiteIntegrationList(communityId: string, listId: string) {
    await axios.delete(`${import.meta.env.VITE_API_URL}/adv-wall-admin/${communityId}/widgets/${listId}`);
  },
};
